import { render, staticRenderFns } from "./ServiceDescription.vue?vue&type=template&id=7712e88c"
import script from "./ServiceDescription.vue?vue&type=script&lang=js"
export * from "./ServiceDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports